<template>
  <v-container
    fluid
    tag="section"
  >
    <v-card>
      <v-card-text>
        <v-row
          dense
          class="align-center"
        >
          <v-col
            cols="12"
            class="d-flex flex-wrap justify-end"
          >
            <v-btn
              color="primary"
              outlined
              class="ma-1"
              @click="openFilter"
            >
              <v-icon class="ml-3">
                mdi-filter-variant
              </v-icon>
              <span class="mx-3">Фильтры</span>
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="ma-1"
              :disabled="loading"
              @click="csv"
            >
              <v-icon class="ml-3">
                mdi-download
              </v-icon>
              <span class="mx-3">Выгрузить CSV</span>
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="ma-1"
              :loading="loading"
              @click="load"
            >
              <v-icon class="ml-3">
                mdi-refresh
              </v-icon>
              <span class="mx-3">Обновить</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-tabs v-model="tab">
          <v-tab
            v-for="t in tabs"
            :key="t.key"
          >
            {{ t.name }}
          </v-tab>
        </v-tabs>

        <v-alert
          v-if="limitAlert"
          type="warning"
          text
          class="mt-2 mb-0"
        >
          Показаны первые 500 записей, сузьте фильтры
        </v-alert>

        <v-tabs-items v-model="tab">
          <!-- Опоздавшие -->
          <v-tab-item key="latecomers">
            <template v-if="reportData.latecomers.by_day && reportData.latecomers.by_day.length">
              <div class="text-h6 pa-2">
                По дням
              </div>
              <v-data-table
                :headers="headers.by_day"
                :items="reportData.latecomers.by_day"
                :loading="loading"
                :footer-props="datatable_footer"
                no-data-text="Нет данных для отображения"
                dense
              />
            </template>
            <template v-if="reportData.latecomers.by_group && reportData.latecomers.by_group.length">
              <div class="text-h6 pa-2">
                По группам
              </div>
              <v-data-table
                :headers="headers.by_group"
                :items="reportData.latecomers.by_group"
                :loading="loading"
                :footer-props="datatable_footer"
                no-data-text="Нет данных для отображения"
                dense
              />
            </template>
            <template v-if="reportData.latecomers.top_subjects && reportData.latecomers.top_subjects.length">
              <div class="text-h6 pa-2">
                Топ-20
              </div>
              <v-data-table
                :headers="headers.top_subjects"
                :items="reportData.latecomers.top_subjects"
                :loading="loading"
                :footer-props="datatable_footer"
                no-data-text="Нет данных для отображения"
                dense
              />
            </template>
            <div
              v-if="emptyReport('latecomers')"
              class="pa-4"
            >
              Нет данных для отображения
            </div>
          </v-tab-item>

          <!-- Ранние уходы -->
          <v-tab-item key="early_leavers">
            <v-data-table
              :headers="headers.early_leavers"
              :items="reportData.early_leavers.items || []"
              :loading="loading"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
              dense
            />
          </v-tab-item>

          <!-- Подозрительные -->
          <v-tab-item key="suspicious">
            <v-data-table
              :headers="headers.suspicious"
              :items="reportData.suspicious.items || []"
              :loading="loading"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
              dense
            >
              <template v-slot:item.direction_mismatch="{ item }">
                <v-chip
                  small
                  :color="item.direction_mismatch ? 'red' : 'grey'"
                  dark
                >
                  {{ item.direction_mismatch ? 'Да' : 'Нет' }}
                </v-chip>
              </template>
              <template v-slot:item.suspicious="{ item }">
                <v-chip
                  small
                  :color="item.suspicious ? 'red' : 'grey'"
                  dark
                >
                  {{ item.suspicious ? 'Да' : 'Нет' }}
                </v-chip>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <skud-filter-dialog
      v-for="t in tabs"
      :key="t.key"
      :ref="'filter_' + t.key"
      :fields="t.fields"
      :storage-key="'skud.report.' + t.key"
      @apply="onFilterApply(t.key, $event)"
    />
  </v-container>
</template>

<script>
import SkudFilterDialog from '@/views/skud/components/SkudFilterDialog.vue'
import { SkudReportService } from '@/views/skud/shared/services/skud-report-service'
import { downloadCsv } from '@/views/skud/shared/modules/skud-http'

const PERIOD = [
  { name: 'С', field: 'from', type: 'date' },
  { name: 'По', field: 'to', type: 'date' }
]

const DIMENSION_LATECOMERS = [
  { value: 'by_day', text: 'По дням' },
  { value: 'by_group', text: 'По группам' },
  { value: 'top_subjects', text: 'Топ субъектов' }
]

export default {
  name: 'SkudReportPage',
  components: {
    SkudFilterDialog
  },
  data () {
    return {
      service: null,
      tab: 0,
      loading: false,
      loaded: {},
      filters: {
        latecomers: {},
        early_leavers: {},
        suspicious: {}
      },
      reportData: {
        latecomers: {},
        early_leavers: {},
        suspicious: {}
      },
      datatable_footer: { itemsPerPageOptions: [5, 10, 15, 30, 50] },
      tabs: [
        {
          key: 'latecomers',
          name: 'Опоздавшие',
          fields: {
            main: {
              index: 0,
              name: 'Отбор',
              data: [
                ...PERIOD,
                { name: 'Группа', field: 'group_ref', type: 'text' },
                { name: 'Измерение', field: 'dimension', type: 'select', select: DIMENSION_LATECOMERS }
              ]
            }
          }
        },
        {
          key: 'early_leavers',
          name: 'Ранние уходы',
          fields: {
            main: {
              index: 0,
              name: 'Отбор',
              data: [
                ...PERIOD,
                { name: 'Группа', field: 'group_ref', type: 'text' },
                { name: 'Лимит', field: 'limit', type: 'number' }
              ]
            }
          }
        },
        {
          key: 'suspicious',
          name: 'Подозрительные',
          fields: {
            main: {
              index: 0,
              name: 'Отбор',
              data: [
                ...PERIOD,
                { name: 'Группа', field: 'group_ref', type: 'text' },
                { name: 'Лимит', field: 'limit', type: 'number' }
              ]
            }
          }
        }
      ],
      headers: {
        by_day: [
          { text: 'Дата', value: 'date' },
          { text: 'Место', value: 'place_name' },
          { text: 'Опозданий', value: 'count' }
        ],
        by_group: [
          { text: 'Группа', value: 'group_ref' },
          { text: 'Место', value: 'place_name' },
          { text: 'Опозданий', value: 'count' }
        ],
        top_subjects: [
          { text: 'Субъект', value: 'subject_ref' },
          { text: 'Место', value: 'place_name' },
          { text: 'Опозданий', value: 'count' }
        ],
        early_leavers: [
          { text: 'Время', value: 'occurred_at' },
          { text: 'Субъект', value: 'subject_ref' },
          { text: 'Группа', value: 'group_ref' },
          { text: 'Точка', value: 'point_id' },
          { text: 'Место', value: 'place_name' }
        ],
        suspicious: [
          { text: 'Время', value: 'occurred_at' },
          { text: 'Субъект', value: 'subject_ref' },
          { text: 'Экран', value: 'screen' },
          { text: 'Причина', value: 'reason' },
          { text: 'Несовпадение направления', value: 'direction_mismatch' },
          { text: 'Подозрительный', value: 'suspicious' },
          { text: 'Место', value: 'place_name' }
        ]
      }
    }
  },
  computed: {
    currentKey () {
      return this.tabs[this.tab].key
    },
    limitAlert () {
      if (this.currentKey !== 'early_leavers' && this.currentKey !== 'suspicious') return false
      const items = this.reportData[this.currentKey].items
      return items && items.length === 500
    }
  },
  watch: {
    tab () {
      if (!this.loaded[this.currentKey]) {
        this.load()
      }
    }
  },
  mounted () {
    this.service = new SkudReportService()
    this.$nextTick(() => {
      for (const t of this.tabs) {
        const ref = this.$refs['filter_' + t.key]
        if (ref && ref[0]) {
          this.$set(this.filters, t.key, ref[0].current())
        }
      }
      this.load()
    })
  },
  methods: {
    params (key) {
      const p = { ...this.filters[key] }
      if ((key === 'early_leavers' || key === 'suspicious') && !p.limit) {
        p.limit = 100
      }
      return p
    },
    openFilter () {
      const ref = this.$refs['filter_' + this.currentKey]
      if (ref && ref[0]) ref[0].open()
    },
    onFilterApply (key, values) {
      this.$set(this.filters, key, values)
      if (key === this.currentKey) this.load()
    },
    emptyReport (key) {
      if (!this.loaded[key]) return false
      const data = this.reportData[key]
      return !Object.keys(data).some(k => Array.isArray(data[k]) && data[k].length)
    },
    async load () {
      if (!this.service) return
      const key = this.currentKey
      this.loading = true
      let data = null
      if (key === 'latecomers') {
        data = await this.service.getLatecomers(null, this.params(key))
      } else if (key === 'early_leavers') {
        data = await this.service.getEarlyLeavers(null, this.params(key))
      } else {
        data = await this.service.getSuspicious(null, this.params(key))
      }
      this.loading = false
      if (!data || !Object.keys(data).length) {
        this.$set(this.loaded, key, true)
        this.$set(this.reportData, key, {})
        this.$store.commit('snackbar', 'Ошибка при получении данных')
        return
      }
      this.$set(this.reportData, key, data)
      this.$set(this.loaded, key, true)
    },
    async csv () {
      const key = this.currentKey
      const ok = await downloadCsv(`reports/${key}`, this.params(key), key + '.csv')
      this.$store.commit('snackbar', ok ? 'Файл загружен' : 'Ошибка при выгрузке')
    }
  }
}
</script>
